// extracted by mini-css-extract-plugin
export default {"container":"Forgot_container__8YxtD","subContainer":"Forgot_subContainer__vTkpF","leftArrow":"Forgot_leftArrow__T6oIs"};